import { Select as AntSelect } from 'antd';
import { colours } from 'utils/theme';
import styled from 'styled-components';
import { Tooltip, Icon } from 'components/common';
import { toExcluded } from 'utils/search';
import IncludeExclude from './IncludeExclude';
import { Token } from './TokenInput';

const { Option } = AntSelect;

const InnerContainer = styled.div`
  display: flex;
  padding: 5px 12px;
  .item {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const TokenContainer = styled.div`
  display: flex;
  margin-top: 3px;
  height: 29px;
`;

export const renderOption = (o, i) => (
  <Option
    title={o}
    key={`${o}-${i}`}
    value={o}
    details={o}
    label={o}
    style={{ color: '#595959' }}
  >
    {o}
  </Option>
);

export const renderOptionIncludeExclude = (
  o,
  i,
  isSelected,
  isExcluded,
  handleChange,
  handleExcludeChange,
  disabledTooltipText
) => {
  return (
    <Option
      title={o.label}
      key={`${o.value}-${i}`}
      value={o.value}
      label={o.label}
      style={{
        padding: 0,
        backgroundColor: isSelected
          ? colours.inlcudeFilter
          : isExcluded
          ? colours.excludeFilter
          : 'inherit',
      }}
      disabled={o.isDisabled}
      display={
        <TokenContainer>
          <Token
            value={isExcluded ? toExcluded(o.label) : o.label}
            handleChange={() => handleChange()}
          />
        </TokenContainer>
      }
    >
      <Tooltip
        title={o.isDisabled ? disabledTooltipText : ''}
        placement='right'
      >
        <InnerContainer
          onClick={e => {
            if (o.isDisabled) return;
            handleChange(o.value);
            e.stopPropagation();
          }}
        >
          <div className='item'>
            {o.isDisabled && (
              <span style={{ marginRight: '8px' }}>
                <Icon size='1x' icon='error' color={'#d9d9d9'} />
              </span>
            )}
            {o.label}
          </div>
          {!o.disableExclude && !o.isDisabled && (
            <IncludeExclude
              isSelected={isSelected}
              isExcluded={isExcluded}
              onExclude={e => {
                handleExcludeChange(o.value);
                e.stopPropagation();
              }}
            />
          )}
        </InnerContainer>
      </Tooltip>
    </Option>
  );
};
